import { ReactNode } from "react"

interface KeyInsightProps {
  children: ReactNode
}

export function KeyInsight({ children }: KeyInsightProps) {
  return (
    <blockquote className="my-8 pl-6 border-l-2 border-accent-secondary bg-accent-secondary/5 py-4 pr-4 rounded-r-lg">
      <p className="text-lg text-foreground/95 italic leading-relaxed">
        {children}
      </p>
    </blockquote>
  )
}
